import { useState } from "react";
import Container from "@mui/material/Container";
import OrdersTable from "./OrdersTable";

function OrdersTab() {
  const [searchValue, setSearchValue] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const [showInput, setShowInput] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <div>
      <Container maxWidth={false} sx={{ my: 3 }}>
        <OrdersTable
          setSearchValue={setSearchValue}
          updateRefreshKey={setRefreshKey}
          searchInput={searchValue}
          query={query}
          setQuery={setQuery}
          setShowInput={setShowInput}
          refreshKey={refreshKey}
          showInput={showInput}
        />
      </Container>
    </div>
  );
}

export default OrdersTab;
